import {Injectable, Injector} from '@angular/core';
import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Router} from '@angular/router';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {MaintenanceService} from './services/maintenance.service';
import {UserRoleService} from './services/userRole.service';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  private maintenanceService: MaintenanceService;
  private userRoleService: UserRoleService;

  constructor(
    private router: Router,
    private injector: Injector,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(req).pipe(
      catchError(err => {
        this.maintenanceService ??= this.injector.get(MaintenanceService);
        this.userRoleService ??= this.injector.get(UserRoleService);
        if (this.userRoleService.hasRole('Admin')) {
          return throwError(() => err);
        }
        if (err.status === 503 && err.headers?.get('X-Maintenance') === 'true') {
          this.router.navigate(['/wartung']);
        } else if (err.status === 401 && this.maintenanceService.currentStatus?.maintenanceRunning) {
          this.router.navigate(['/wartung']);
        }
        return throwError(() => err);
      })
    );
  }
}
